import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Renders title and company on separate lines so a long title does not force
 * the company string to wrap mid-phrase (e.g. "gvm" / "technologies").
 */
export function TitleCompanyStack({ title, company, titleSx = {}, companySx = {}, boxSx = {} }) {
  const t = (title || '').trim();
  const c = (company || '').trim();
  if (!t && !c) return null;
  return (
    <Box sx={{ maxWidth: '100%', ...boxSx }}>
      {t ? (
        <Typography component="div" sx={{ wordBreak: 'break-word', ...titleSx }}>
          {t}
        </Typography>
      ) : null}
      {c ? (
        <Typography component="div" sx={{ wordBreak: 'break-word', mt: t ? 0.35 : 0, ...companySx }}>
          {c}
        </Typography>
      ) : null}
    </Box>
  );
}
